import {userAddSuccess, userAddError} from "./reducer";
import {postAddUser} from "../../../helpers/user_helper";

export const addUser = (payload) => async (dispatch) => {
  try {
    let response;
    payload.roles = ["ROLE_CLUB_ADMIN"];
    response = postAddUser(
      payload
    );
    const data = await response;

    if (data) {
      dispatch(userAddSuccess(data));
    }
  } catch (error) {
    dispatch(userAddError(error));
  }
};
